import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '../messages/Tooltip';
import Button from '../buttons/Button';
import Spinner from '../spinner';

const ExcelExport = ({ onClick, loading, tooltip, disabled }) => {
  return (
    <>
      {tooltip && <Tooltip id="xlsTip" />}
      <button
        data-for="xlsTip"
        data-tip={tooltip}
        className="button gray-light icon-file-excel"
        disabled={disabled || loading}
        onClick={onClick}
      >
        {loading && <span>Augnablik</span>}
        {!loading && <span>Excel</span>}
      </button>
    </>
  );
};

// ExcelExport.propTypes = {
//   onClick: PropTypes.func,
//   loading: PropTypes.bool,
//   tooltip: PropTypes.string
// };

// ExcelExport.defaultProps = {
//   loading: false
// };

export default ExcelExport;
